import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { Attendance } from "@/@types/sintegrada/Attendance";

type Props = {
	evadedAttendances: Attendance[];
};

export function MedicalAttendanceEvasionsTable({ evadedAttendances }: Props) {
	return (
		<Table className="text-start">
			<thead>
				<tr>
					<th>Data da evasão</th>
					<th>Paciente</th>
					<th>Unidade de saúde</th>
				</tr>
			</thead>
			<tbody>
				{evadedAttendances.map((evadedAttendance, index) => (
					<tr key={`medical-attendance-evasions-table-row-${index}`}>
						<td>
							{evadedAttendance.medicalAttendanceEvasionDate
								? dayjs(evadedAttendance.medicalAttendanceEvasionDate).format(
										"DD/MM/YYYY HH:mm"
								  )
								: "Não informado"}
						</td>
						<td>{evadedAttendance.patient?.name ?? "Não informado"}</td>
						<td>{evadedAttendance.healthUnit?.name ?? "Não informado"}</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}
